const budget = 2;

class RAFQueue {
    #queue = [];
    #raf = null;

    // Queue a callback for a frame-budgeted flush.
    add(callback) {
        if (typeof callback !== "function") {
            return;
        }

        this.#queue.push(callback);
        this.#schedule();
    }

    #run = () => {
        this.#raf = null;

        if (this.#queue.length === 0) {
            return;
        }

        const deadline = performance.now() + budget;

        while (this.#queue.length) {
            const callback = this.#queue.shift();

            try {
                callback();
            } catch (error) {
                queueMicrotask(() => {
                    throw error;
                });
            }

            if (performance.now() >= deadline) {
                break;
            }
        }

        if (this.#queue.length) {
            this.#schedule();
        }
    };

    #schedule() {
        if (this.#raf === null) {
            this.#raf = requestAnimationFrame(this.#run);
        }
    }
}

export default new RAFQueue();
